// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__-oM8f","containerItemsCenter":"Skeleton_containerItemsCenter__2xIqA"};